var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row wrapper-spacing" }, [
    _vm.items.length
      ? _c("div", { staticClass: "small-12 columns" }, [
          _c("h1", [
            _vm._v("Monatliche Indexentwicklung "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.indexName) } }),
            _vm._v(" " + _vm._s(_vm.month))
          ]),
          _c("div", { staticClass: "spv-table-wrapper" }, [
            _c(
              "table",
              {
                staticClass:
                  "spv-product-table spv-index-table spv-index-table--vip-euro"
              },
              [
                _c("thead", [
                  _c("tr", { staticClass: "tr-thick-border" }, [
                    _c("th", { staticClass: "th-caption medium-6" }, [
                      _vm._v("Monat")
                    ]),
                    _c("th", { staticClass: "th-caption medium-3" }, [
                      _c(
                        "div",
                        { staticClass: "spv-info-wrapper flex-wrapper" },
                        [
                          _c("span", [_vm._v("Index­ent­wick­lung")]),
                          _c("div", { staticClass: "info-overlay" }, [
                            _vm._m(0),
                            _c(
                              "div",
                              { staticClass: "info-overlay__text right-auto" },
                              [_vm._v(_vm._s(_vm.infoTexts[0]))]
                            )
                          ])
                        ]
                      )
                    ]),
                    _c("th", { staticClass: "th-caption medium-3" }, [
                      _c(
                        "div",
                        { staticClass: "spv-info-wrapper flex-wrapper" },
                        [
                          _c("span", [
                            _vm._v("Mit Cap bei " + _vm._s(_vm.targetVol))
                          ]),
                          _c("div", { staticClass: "info-overlay" }, [
                            _vm._m(1),
                            _c("div", {
                              staticClass: "info-overlay__text",
                              domProps: { innerHTML: _vm._s(_vm.infoTexts[1]) }
                            })
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.items, function(item, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(_vm.formatDate(item.date)))]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.formatPercent(item.index_value_percent, 2))
                        )
                      ]),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatPercent(item.index_cap, 2)))
                      ])
                    ])
                  })
                ),
                _c("tfoot", [
                  _c("tr", [
                    _c("td", [_vm._v(" ")]),
                    _c("td", { staticClass: "td-padding" }, [
                      _c(
                        "div",
                        { staticClass: "spv-info-wrapper overlay-sm-flex" },
                        [
                          _vm._v("Jahres­rendite"),
                          _c("div", { staticClass: "info-overlay" }, [
                            _vm._m(2),
                            _c("div", {
                              staticClass: "info-overlay__text right-auto",
                              domProps: { innerHTML: _vm._s(_vm.infoTexts[3]) }
                            })
                          ])
                        ]
                      )
                    ]),
                    _c("td", [
                      _vm._v(_vm._s(_vm.formatPercent(_vm.yearlyYield, 2)))
                    ])
                  ]),
                  _c("tr", [
                    _c("td", [_vm._v(" ")]),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "spv-info-wrapper hide-all show-medium show-large"
                        },
                        [
                          _vm._v("Maßgebliche"),
                          _c("div", { staticClass: "info-overlay" }, [
                            _vm._v("Jahresrendite"),
                            _vm._m(3),
                            _c(
                              "div",
                              { staticClass: "info-overlay__text right-auto" },
                              [_vm._v(_vm._s(_vm.infoTexts[2]))]
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "spv-info-wrapper overlay-sm-flex hide-all show-small"
                        },
                        [
                          _vm._v("Maßgebliche Jahres­rendite"),
                          _c("div", { staticClass: "info-overlay" }, [
                            _vm._m(4),
                            _c(
                              "div",
                              { staticClass: "info-overlay__text right-auto" },
                              [_vm._v(_vm._s(_vm.infoTexts[2]))]
                            )
                          ])
                        ]
                      )
                    ]),
                    _c("td", [
                      _vm._v(_vm._s(_vm.formatPercent(_vm.decisiveYield, 2)))
                    ])
                  ])
                ])
              ]
            )
          ]),
          _c("div", { staticClass: "pdf-button-wrapper" }, [
            _c(
              "a",
              {
                staticClass: "button button-small",
                on: {
                  click: function($event) {
                    _vm.$emit("print")
                  }
                }
              },
              [_vm._v("Drucken")]
            )
          ])
        ])
      : _c("div", { staticClass: "medium-12 large-12 columns" }, [
          _c("h1", { staticClass: "no-margin" }, [
            _vm._v("Keine Monatswerte für "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.indexName) } }),
            _vm._v(" für " + _vm._s(_vm.month) + " vorhanden.")
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon header-info" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon header-info" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64d3344c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d3344c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/index/index-euro-table.vue
// module id = TirD
// module chunks = 0